// extracted by mini-css-extract-plugin
export var activeDot = "_41-c";
export var buttonContainer = "_41-9";
export var channelButton = "_41-a";
export var clickable = "_41-d";
export var content = "_41-0";
export var contentFull = "_41-2";
export var contentThird = "_41-1";
export var contentWrapper = "_41-7";
export var description = "_41-5";
export var heightShort = "_41-f";
export var image = "_41-3";
export var imageContainer = "_41-4";
export var selectButton = "_41-e";
export var spinnerContainer = "_41-b";
export var titleContent = "_41-8";
export var titleWrapper = "_41-6";